module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/home/code_ios.png")
    }
  }), _vm._v(" "), _c('el-button', {
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-ios"
  }), _vm._v(" iOS\n\t\t\t")])], 1), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/home/code_android.png")
    }
  }), _vm._v(" "), _c('el-button', {
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-anzhuo"
  }), _vm._v("Android")])], 1)], 1), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(item.desc))])])
  })), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/home/phone.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": require("../../assets/img/home/logo_2.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("物联网控制APP")]), _vm._v(" "), _c('div', [_vm._v("智能生活·一手掌握")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3dda08ee"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_5.vue
// module id = 777
// module chunks = 1